<template>
  <v-footer
    light
    padless
    
  >
    <v-card
      width="100%"
      flat
      tile
      class="w-100 lighten-1 pt-10 text-center"
    >
      
      <v-card-text>
        <div class="m-auto pb-6"><img src="/img/logo_GlobalSocial.jpeg" height="200"/></div>
        <p class="title font-weight-light black--text">{{$t('in_cooperation_with')}}</p>
        <div class="m-auto pb-6"><img src="/img/logo_sofareisen_text.png" height="200"/></div>
        
        <h3 class="title font-weight-light black--text px-5 mt-0" style="max-width:550px;margin:auto;">{{$t('gsn_slogan')}}</h3>
        <p class="pa-5">
          <a href="https://www.globalsocial-network.org/" target="_blank">https://www.globalsocial-network.org/</a>
          <br/><br/>
          <a href="mailto:info@globalsocial-network.org">info@globalsocial-network.org</a>
          </p>
        <div class="black--text px-5 mt-0 pt-2 mb-12" style="max-width:550px;margin:auto; border:1px solid black;">
          <div class="title font-weight-light">{{$t('gsn_donation_form')}}</div>
          <p>
            GlobalSocial-network e.V.<br/>
            Kreissparkasse Saalfeld / Rudolstadt<br/><br/>
            IBAN: DE88 8305 0303 0011 0253 60<br/>
            BIC: HELADEF1SAR<br/><br/>
            GlobalSocial-network e.V. (Amtsgericht Saalfeld, VR 2706 58) ist beim Finanzamt als gemeinnützige Organisation anerkannt und von der Körperschaftssteuer befreit. Ihre Spende ist somit steuerlich absetzbar.
          </p>
        </div>
        <v-row align="end" class="hl-text-black" style="max-width:900px; margin:auto;">
          <!-- Menu left -->
          <v-col cols="12" sm="4">
            <v-row v-for="(item,index) in menu" :key="'btnFooterText-'+index" class="pa-1 caption" :justify="(isXsDevice)?'center':'left'">
              <router-link rel="preload" :to="item.link">{{item.title}}</router-link>
            </v-row>
          </v-col>
          <!-- Icons center -->
          <v-col cols="12" sm="4">
            <v-btn
              v-for="icon in icons"
              :key="icon.icon"
              :href="icon.link"
              target="_blank"
              color="black"
              class="mx-4 "
              icon
            >
              <v-icon size="39px">{{ icon.icon }}</v-icon>
            </v-btn>
          </v-col>
          <!-- Copyrights right -->
          <v-col cols="12" sm="4" class="caption hl-text-black">
            © {{ new Date().getFullYear() }} GlobalSocial-network e.V.
          </v-col>
        </v-row>
      </v-card-text>
      
    </v-card>
  </v-footer>
</template>

<script>
import {settingsMixin} from '@/utils/settings-mixin'
import {layoutMixin} from '@/utils/layout-mixin'
//import trans from '@/locale/trans'

export default {
  mixins: [settingsMixin,layoutMixin],
  computed: {
    menu(){
      return [
        { title: this.$t('menu_imprint'), link:'/impressum' },
        { title: this.$t('menu_data_protection'),link:'/datenschutz' }
      ]
    }
  },
  data () {
    return {
      icons: [
        {icon:'mdi-facebook',link:'https://www.facebook.com/AxelBruemmerPeterGloeckner/'},
        {icon:'mdi-home-variant',link:'https://www.globalsocial-network.org/'}
      ]
    }
  },
  methods:{

  }
}
</script>
